/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { DataService } from 'app/shared/services/data.service';
import { AuthService } from 'app/core/security/auth/auth.service';
import { UserAccount, Permission } from './user-account.model';
import { Injectable } from '@angular/core';
import { Constants } from 'app/core/models/constants';
import { HttpClient } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class PermissionsService extends DataService<any> {

  private _userAccount: UserAccount;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private apiDependencies: ApiDependenciesService) { 
      super(apiDependencies);
    }

  public checkModulePermission(modulePermission: string): boolean {
    // TODO implement module permission check logic
    return true;
  }

  async getPermissions(): Promise<UserAccount> {
    if (this._userAccount) {
      return Promise.resolve(this._userAccount);
    }

    await this.requestPermissionsAsync().then((userAccount: UserAccount) => {
      this._userAccount = userAccount;
    });
    return Promise.resolve(this._userAccount);
  }

  // TODO(WH) does this need to be called as /auth/permission/{id} gives a 404?
  async requestPermissionsAsync(): Promise<UserAccount> {
    const result = new UserAccount();
    const cookieValue = this.apiDependencies.cookieService.get(Constants.Cookies.KeyLoggedInUserId);
    const loggedInUerId = +cookieValue;
    const userId: number = this.auth.loggedInUserId &&  this.auth.loggedInUserId !== -1 ? this.auth.loggedInUserId : loggedInUerId;
    
    this.endpoint = '/auth/permission/' + userId;
    // await this
    // .getSingle()
    // .then((results: UserAccount) => {
    //   result = results;
    // });
    
    result.id = userId;
    result.email = '';
    result.permissions = new Array<Permission>();
    result.roles = new Array<string>();
    result.userName = '';

    return Promise.resolve(result);
  }

  private handleError(err: any) {
    if (err.status === 401) {
      // TODO router not injecting!?!
      // this.router.navigate(['login']);
    }
  }
}
